/**
 * We observed issues with next/image, where sometimes the image isn't shown in Google Chrome (but loaded and cached!).
 * This is a workaround to force the image to reload if it fails to load.
 *
 * To apply the workaround, do the following:
 *
 * ```tsx
 * <Image src="…" onError={forceImgReloadOnError} />
 * ```
 *
 * The onError handler registration triggers a special code path within Next.js that causes `img.src = img.src` to
 * be executed and that fixes the problem. Based on what we can guess, this seems to be a bug in Chrome, as we are
 * unable to reproduce this issue in Safari.
 */
export function forceImgReloadOnError(error: any) {
    console.error(`Failed to load image`, error);
}